import { useState } from "react";

import { Modal } from "semantic-ui-react";

import CardPackageOrder from "react-lib/apps/HISV3/HCU/CardPackageOrder";
import ModPackageDetail, { CARD_MOD_PACKAGE_DETAIL } from "../HISV3/HCU/ModPackageDetail";
import { PackageDetailType } from "../HISV3/HCU/sequence/SettingPackage";
import CardMakeAppointmentMeHey from "./appointments/CardMakeAppointmentMeHey";
import ModInfoOA from "../IsHealth/REG/ModInfoOA";

import { State as PackagePurchaseState } from "../HISV3/HCU/sequence/PackagePurchase";
import { State as PackageOrderState } from "../HISV3/HCU/sequence/PackageOrder";
import { State as MakeAppointmentMeHeyState } from "react-lib/apps/MEH/sequence/MakeAppointmentMeHey";
import { State as MainState } from "HIS/MainHISInterface";

import "react-lib/apps/MEH/CardMeBillingPackage.scss";

type CardMePackageOrderProps = {
  setProp: any;
  controller: any;
  runSequence: any;
  onEvent: any;
  // sequence
  PackagePurchaseSequence?: PackagePurchaseState["PackagePurchaseSequence"];
  PackageOrderSequence?: PackageOrderState["PackageOrderSequence"];
  MakeAppointmentMeHeySequence?: MakeAppointmentMeHeyState["MakeAppointmentMeHeySequence"];
  // CommonInterface
  selectedPatient?: Record<string, any>;
  searchedItemListWithKey?: Record<string, any>;
  languageUX: "en" | "th";
  // Master / Task
  masterOptions?: Record<string, any[]>;
  masterData?: Record<string, any[]>;
  // CardMedicalFee
  patientInfo?: Record<string, any>;
  selectedEncounter?: Record<string, any>;
   // Invoice items
  invoiceItemByModes?: Record<string, any>[];
  invoiceItemByOrders?: Record<string, any>[];
  invoiceItemByItems?: Record<string, any>[];
  invoiceItemPackageList?: Record<string, any>[];
  // Orders
  patientOrders?: Record<string, any>[];
  refundOrders?: Record<string, any>;
  // Filters / Status
  medicalFeeFilter?: Record<string, any>;
  patientEncounterLockerStatus?: Record<string, any>[];
  encounterSuspension?: Record<string, any>;
  // Bill / Payment
  BillPaymentSequence?: Record<string, any> | null;
  billPendingDetail?: Record<string, any>;
  billReportPrint?: Record<string, any>;
  bilReceiptCodeDetail?: Record<string, any>;
  faxClaimItemList?: Record<string, any>;
  taskTrackingList?: Record<string, any>;
  // Language
  billingPatientLanguage?: any;
  // config
  showMedicalFee?: boolean;
} & Pick<MainState, "buttonLoadCheck" | "errorMessage" | "successMessage">;

const CardMePackageOrder = (props: CardMePackageOrderProps) => {
  const [modPackageDetail, setModPackageDetail] = useState<PackageDetailType | null>();
  const [openModAppointment, setOpenModAppointment] = useState<boolean>(false);
  const [openModInfo, setOpenModInfo] = useState<boolean>(false);

  const handleCancelPackage = (reason: string) => {
    props.runSequence({
      sequence: "PackagePurchase",
      action: "CANCEL_PACKAGE",
      card: CARD_MOD_PACKAGE_DETAIL,
      data: {
        orderId: modPackageDetail?.id,
        packageId: modPackageDetail?.product,
        quantity: modPackageDetail?.quantity,
        reason,
      },
      inCartFilter: false,
      onSuccess: () => setModPackageDetail(null),
    });
  };

  const handleCloseModAppointment = () => {
    setOpenModAppointment(false);

    props.setProp(`PackagePurchaseSequence.selectPackageBinder`, {});
  };

  const handleCloseModInfo = () => {
    setOpenModInfo(false);
  };

  const handleAppointmentSuccess = () => {
    handleCloseModAppointment();

    props.runSequence({
      sequence: "PackagePurchase",
      action: "SEARCH",
      card: "CardPackagePurchaseHistory",
      statusesFilter: ["BILLED", "PAID"],
      inCartFilter: false,
      filterByDivision: true,
    });

    setOpenModInfo(true);
  };

  return (
    <div className="CardMeBillingPackage">
      <CardPackageOrder
        setProp={props.setProp}
        onEvent={props.onEvent}
        // seq
        runSequence={props.runSequence}
        PackagePurchaseSequence={props.PackagePurchaseSequence}
        PackageOrderSequence={props.PackageOrderSequence}
        // Filter
        statusesFilter={["BILLED", "PAID"]}
        inCartFilter={false}
        // CommonInterface
        searchedItemListWithKey={props.searchedItemListWithKey}
        buttonLoadCheck={props.buttonLoadCheck}
        errorMessage={props.errorMessage}
        successMessage={props.successMessage}
        packageBinderTitle="สั่ง Order"
        confirmHeaderText="ยืนยันการส่งรายการของผู้ให้บริการ"
        selectPromptText="กรุณาเลือกรายการที่ต้องการส่งคำสั่ง"
        confirmButtonText="ยืนยันคำสั่ง"
        hideTitle
        hidePackageTypeFilter
        hideProgramNameFilter
        hideDivisionFilter
        showPackageNameFilter
        showOptimizePackage
        filterByDivision
        onClickDescription={setModPackageDetail}
        onClickAppointment={() => {
          setOpenModAppointment(true);
        }}
        // options
        masterData={props.masterData}
        masterOptions={props.masterOptions}
        languageUX={props.languageUX}
        // medicalfee
        patientInfo={props.patientInfo}
        selectedEncounter={props.selectedEncounter}
        // Invoice items
        invoiceItemByModes={props.invoiceItemByModes}
        invoiceItemByOrders={props.invoiceItemByOrders}
        invoiceItemByItems={props.invoiceItemByItems}
        invoiceItemPackageList={props.invoiceItemPackageList}
        // Orders
        patientOrders={props.patientOrders}
        refundOrders={props.refundOrders}
        // Filters / Status
        medicalFeeFilter={props.medicalFeeFilter}
        patientEncounterLockerStatus={props.patientEncounterLockerStatus}
        encounterSuspension={props.encounterSuspension}
        // Bill / Payment
        BillPaymentSequence={props.BillPaymentSequence}
        billPendingDetail={props.billPendingDetail}
        billReportPrint={props.billReportPrint}
        bilReceiptCodeDetail={props.bilReceiptCodeDetail}
        faxClaimItemList={props.faxClaimItemList}
        taskTrackingList={props.taskTrackingList}
        // Language
        billingPatientLanguage={props.billingPatientLanguage}
        // config
        isMeBilling={true}
        showMedicalFee={props.showMedicalFee}
      />

      {modPackageDetail && (
        <ModPackageDetail
          open
          data={modPackageDetail}
          onClose={() => {
            setModPackageDetail(null);
          }}
          onCancel={handleCancelPackage}
          setProp={props.setProp}
          buttonLoadCheck={props.buttonLoadCheck}
          masterOptions={props.masterOptions}
          errorMessage={props.errorMessage}
        />
      )}

      <Modal
        open={openModAppointment}
        size="fullscreen"
        closeOnDimmerClick
        onClose={handleCloseModAppointment}
      >
        <CardMakeAppointmentMeHey
          controller={props.controller}
          runSequence={props.runSequence}
          onEvent={props.onEvent}
          setProp={props.setProp}
          MakeAppointmentMeHeySequence={props.MakeAppointmentMeHeySequence}
          searchedItemListWithKey={props.searchedItemListWithKey}
          buttonLoadCheck={props.buttonLoadCheck}
          selectedPatient={props.selectedPatient}
          selectPackageBinder={props.PackagePurchaseSequence?.selectPackageBinder}
          isPackageAppointment={true}
          onClose={handleCloseModAppointment}
          languageUX={props.languageUX}
          onAppointmentSuccess={handleAppointmentSuccess}
        />
      </Modal>

      <ModInfoOA
        open={openModInfo}
        type={"success"}
        btnText="ปิดหน้าต่าง"
        subtitle={"บันทึกนัดหมายสำเร็จ"}
        btnStyle={{ backgroundColor: "#b8b8b8" }}
        onApprove={handleCloseModInfo}
        onClose={handleCloseModInfo}
      />
    </div>
  );
};

export default CardMePackageOrder;
